// import { createPublicClient, http } from 'viem'
import { pulsechain } from 'viem/chains'

export const ethPriceApiUrl = {
 1: 'https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD',
}

export const supportedChainIds = [pulsechain.id]
// export const supportedChainIds = [bsc.id, mainnet.id, base.id, polygon.id, bscTestnet.id, arbitrum.id, avalanche.id, ]

export const shortenAddress = (address: string, length: number) => {
    return address.slice(0, length + 2) + '...' + address.slice(-length)
}
export default function formatNumber(number) {
    if (number >= 1000000) {
        return (number / 1000000).toLocaleString() + 'M';
    } else if (number >= 1000) {
        return (number / 1000).toLocaleString() + 'K';
    } else {
        return number.toString();
    }
}

export const whitelists = ['0x8AEFFD439C843b2d1Aceb7a2422eDDf888152743']
export const ratioContract = '0x84578aE8ab13f657422932725968b52Ad1Eb1053'
export const wtnAddress = '0x9A8734475aDD93E359003BD09EAA29BC0E78B688'
export const rhaaAddress = '0xAFB91728a85Ffe3aEe19f53e07b9c85174728e37'